import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import useDash from "../../assets/css/dash.module.css";
import { FourGround, FontColor } from "../../assets/js/theme";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchpppoeUserForReseller,
  pppoeMACBinding,
  pppoeRemoveMACBinding,
  removeCustomerActiveConnection,
} from "../../features/apiCalls";
import Table from "../../components/table/Table";
import { useTranslation } from "react-i18next";
// get specific customer

import {
  ArrowClockwise,
  Bezier2,
  FilterCircle,
  HddNetworkFill,
  Router,
  Server,
  Shuffle,
  ThreeDots,
  Wifi,
  WifiOff,
} from "react-bootstrap-icons";
import Loader from "../../components/common/Loader";
import {
  getArea,
  getMikrotik,
  getSubAreas,
} from "../../features/apiCallReseller";
import Footer from "../../components/admin/footer/Footer";
import moment from "moment";
import { Accordion } from "react-bootstrap";
import NetFeeBulletin from "../../components/bulletin/NetFeeBulletin";
import { getBulletinPermission } from "../../features/apiCallAdmin";
import { badge } from "../../components/common/Utils";
import BandwidthModal from "../../pages/Customer/BandwidthModal";
import useISPowner from "../../hooks/useISPOwner";
import ONUDetails from "../../pages/activeustomer/ONUDetails";
import useDataState from "../../hooks/useDataState";
import DataFilter from "../../pages/common/DataFilter";
import useSelectorState from "../../hooks/useSelectorState";
import PPPoELiveBandwidth from "../../pages/Customer/PPPoELiveBandwidth";
import { connectSocket } from "../../socket";
import PingDetails from "../../pages/activeustomer/PingDetails";
import MacVendor from "../../pages/activeustomer/MacVendor";

const ResellerActiveCustomer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const filterInputPermission = {
    mikrotik: true,
    package: true,
    area: true,
    subArea: true,
    poleBox: true,
    connectionStatus: true,
    status: true,
  };

  //---> Get user & current user data form useISPOwner hooks
  const { role, bpSettings, userData, currentUser, permission } = useISPowner();

  //---> Get filtered dataset from useDataState hook
  const { filterOptions, setFilterOption } = useDataState();

  //---> Get redux store state data from useSelectorState hooks
  const { areas, subAreas } = useSelectorState();

  // get all mikrotik from redux
  const mikrotik = useSelector((state) => state?.mikrotik?.mikrotik);

  // get all static customer
  let allMikrotikUsers = useSelector((state) => state?.mikrotik?.pppoeUser);

  //---> Get bulletin route permission from redux store
  const butPermission = useSelector(
    (state) => state.adminNetFeeSupport?.bulletinPermission,
  );

  // mikrotik loading state
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // customer state
  let [allUsers, setAllUsers] = useState(allMikrotikUsers);

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  //bandwidth modal state
  const [bandWidthModal, setBandWidthModal] = useState(false);

  // customer id state
  const [bandWidthCustomerData, setBandWidthCustomerData] = useState();

  // modal show state
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);

  const [customer, setCustomer] = useState({});

  // customer bandwidth handler
  const bandwidthModalController = (customer) => {
    setBandWidthCustomerData(customer);
    setBandWidthModal(true);
    setModalStatus("bandwidth");
  };

  // initialize id
  const ids = {
    resellerId: role === "reseller" ? userData.id : userData.reseller,
    mikrotikId: filterOptions.mikrotik,
  };

  //mac-binding handler
  const macBindingCall = (customerId) => {
    pppoeMACBinding(customerId);
  };
  const macBindingRemove = (customerId) => {
    pppoeRemoveMACBinding(customerId);
  };

  //================// API CALL's //================//
  useEffect(() => {
    connectSocket(currentUser?.user.id);

    //---> @Get ispOwner areas data
    !areas?.length && getArea(dispatch, ids?.resellerId, setLoading);

    //---> @Get reseller ispOwner areas sub-area data
    !subAreas.length && getSubAreas(dispatch, ids?.resellerId);

    if (role === "collector") {
      getMikrotik(dispatch, currentUser?.collector.reseller);
    }
    if (role === "reseller") {
      getMikrotik(dispatch, currentUser?.reseller.id);
    }

    //---> @Get netFee bulletin permissions data
    Object.keys(butPermission)?.length === 0 && getBulletinPermission(dispatch);
  }, []);

  // api call for get update static customer
  useEffect(() => {
    if (filterOptions.mikrotik) {
      fetchpppoeUserForReseller(
        dispatch,
        ids,
        mikrotik[0]?.name,
        setIsLoading,
        "user",
      );
    }
  }, [filterOptions.mikrotik]);

  // set mikrotik and customer into state
  useEffect(() => {
    setAllUsers(allMikrotikUsers);
  }, [allMikrotikUsers, mikrotik]);

  // reload handler
  const reloadHandler = () => {
    fetchpppoeUserForReseller(
      dispatch,
      ids,
      mikrotik[0].name,
      setIsLoading,
      "user",
    );
  };

  const connectionPingTest = (customer) => {
    setShow(true);
    setCustomer(customer);
    setModalStatus("ping");
  };

  const handleCustomerRemoveFormActiveConnection = (customer) => {
    const confirm = window.confirm(t("areYouSure"));

    if (confirm) {
      removeCustomerActiveConnection(dispatch, customer?.id, setIsLoading);
    }
  };

  // table column
  const columns = useMemo(
    () => [
      {
        width: "3%",
        Header: <Wifi />,
        accessor: "running",
        Cell: ({ value }) => (
          <div>{value ? <Wifi color="green" /> : <WifiOff color="red" />}</div>
        ),
      },
      {
        width: "5%",
        Header: t("id"),
        accessor: "customerId",
      },
      {
        width: "10%",
        Header: t("namePPPoE"),
        accessor: (data) => `${data?.name} ${data.pppoe?.name}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.name}</p>
            <p>{original.pppoe?.name}</p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("IPMac"),
        accessor: (data) => `${data?.ip} ${data.callerId}`,
        Cell: ({ row: { original } }) => (
          <div style={{ cursor: "pointer" }}>
            <p
              onClick={() => window.open(`http://${original?.ip}`, "_blank")}
              style={{
                cursor: "pointer",
                textDecoration: "none",
                color: "inherit",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
                e.currentTarget.classList.add("text-primary");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
                e.currentTarget.classList.remove("text-primary");
              }}
            >
              {original?.ip}
            </p>

            <p
              className={`text-${original?.macBinding && "success fw-bold"}`}
              onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = "underline";
                e.currentTarget.classList.add("text-primary");
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = "none";
                e.currentTarget.classList.remove("text-primary");
              }}
              onClick={() => {
                setCustomer(original);
                setModalStatus("macVendor");
                setShow(true);
              }}
            >
              {original?.callerId}
            </p>
          </div>
        ),
      },
      {
        width: "10%",
        Header: t("package"),
        accessor: "pppoe.profile",
      },
      {
        width: "8%",
        Header: t("upDown"),
        accessor: (data) => `${data?.rxByte} ${data.txByte}`,
        Cell: ({ row: { original } }) => (
          <div
            style={{
              padding: "15px 15px 15px 0 !important",
            }}
          >
            <p>
              {original?.rxByte
                ? original?.rxByte / 1024 / 1024 <= 1024
                  ? (original?.rxByte / 1024 / 1024).toFixed(2) + " MB"
                  : (original?.rxByte / 1024 / 1024 / 1024).toFixed(2) + " GB"
                : ""}
            </p>

            <p>
              {original?.txByte
                ? original?.txByte / 1024 / 1024 <= 1024
                  ? (original?.txByte / 1024 / 1024).toFixed(2) + " MB"
                  : (original?.txByte / 1024 / 1024 / 1024).toFixed(2) + " GB"
                : ""}
            </p>
          </div>
        ),
      },
      {
        width: "8%",
        Header: t("uptime"),
        accessor: "uptime",
        Cell: ({ row: { original } }) => (
          <div>
            {original?.uptime ? (
              original?.uptime
            ) : (
              <p className="text-danger">
                {(() => {
                  const diffInSeconds = moment().diff(
                    moment(original?.lastLogoutTime),
                    "seconds",
                  );

                  const weeks = Math.floor(diffInSeconds / (60 * 60 * 24 * 7));
                  const days = Math.floor(
                    (diffInSeconds % (60 * 60 * 24 * 7)) / (60 * 60 * 24),
                  );
                  const hours = Math.floor(
                    (diffInSeconds % (60 * 60 * 24)) / (60 * 60),
                  );
                  const minutes = Math.floor((diffInSeconds % (60 * 60)) / 60);
                  const seconds = diffInSeconds % 60;

                  return (
                    <>
                      {weeks > 0 && <span>{weeks}w</span>}
                      {days > 0 && <span>{days}d</span>}
                      {hours > 0 && <span>{hours}h</span>}
                      {minutes > 0 && <span>{minutes}m</span>}
                      <span>{seconds}s</span>
                    </>
                  );
                })()}
              </p>
            )}
          </div>
        ),
      },
      {
        width: "15%",
        Header: t("loggedInOut"),
        accessor: (data) => `${data?.lastLinkUpTime} ${data?.lastLogoutTime}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>
              {original?.lastLinkUpTime &&
                moment(original.lastLinkUpTime).format("YYYY/MM/DD hh:mm A")}
            </p>
            <p>
              {original?.lastLogoutTime &&
                moment(original.lastLogoutTime).format("YYYY/MM/DD hh:mm A")}
            </p>
          </div>
        ),
      },
      {
        width: "5%",
        Header: t("status"),
        accessor: (data) => data.status,
        Cell: ({ row: { original } }) => <div>{badge(original?.status)}</div>,
      },
      {
        width: "5%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",
        Cell: ({ row: { original } }) => {
          return (
            <div className="text-center">
              <div className="dropdown">
                <ThreeDots
                  className="dropdown-toggle ActionDots"
                  id="areaDropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />

                <ul className="dropdown-menu" aria-labelledby="areaDropdown">
                  {bpSettings?.hasMikrotik &&
                    bpSettings?.hasOLT &&
                    !permission?.oltUserMonitor &&
                    original?.running === true && (
                      <li
                        onClick={() => {
                          setCustomer(original);
                          setModalStatus("onuDetails");
                          setShow(true);
                        }}
                      >
                        <div className="dropdown-item">
                          <div className="customerAction">
                            <HddNetworkFill />
                            <p className="actionP">{t("onuLaser")}</p>
                          </div>
                        </div>
                      </li>
                    )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li onClick={() => bandwidthModalController(original)}>
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Server />
                          <p className="actionP">{t("bandwidth")}</p>
                        </div>
                      </div>
                    </li>
                  )}

                  {role !== "collector" &&
                    bpSettings?.hasMikrotik &&
                    original?.running && (
                      <li>
                        {!original?.macBinding ? (
                          <div
                            className="dropdown-item"
                            onClick={() => macBindingCall(original.id)}
                          >
                            <div className="customerAction">
                              <Router />
                              <p className="actionP">{t("macBinding")}</p>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="dropdown-item"
                            onClick={() => macBindingRemove(original.id)}
                          >
                            <div className="customerAction">
                              <Router />
                              <p className="actionP">{t("removeMACBinding")}</p>
                            </div>
                          </div>
                        )}
                      </li>
                    )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li onClick={() => connectionPingTest(original)}>
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Bezier2 />
                          <p className="actionP">{t("ping")}</p>
                        </div>
                      </div>
                    </li>
                  )}

                  {bpSettings?.hasMikrotik && original?.running === true && (
                    <li
                      onClick={() =>
                        handleCustomerRemoveFormActiveConnection(original)
                      }
                    >
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Shuffle />
                          <p className="actionP">{t("removeConnection")}</p>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    [t],
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              {/* modals */}
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div className="d-flex">
                    <div>{t("activeCustomer")}</div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      onClick={() => {
                        if (!activeKeys) {
                          setActiveKeys("filter");
                        } else {
                          setActiveKeys("");
                        }
                      }}
                      title={t("filter")}
                    >
                      <FilterCircle className="addcutmButton" />
                    </div>

                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          title={t("refresh")}
                          className="arrowClock"
                          onClick={() => reloadHandler()}
                        ></ArrowClockwise>
                      )}
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <DataFilter
                          page="activeCustomer"
                          filterData={allMikrotikUsers}
                          setFilterData={setAllUsers}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          inputPermission={filterInputPermission}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <div className="table-section">
                      <Table
                        isLoading={isLoading}
                        columns={columns}
                        data={allUsers}
                      ></Table>
                    </div>
                  </div>
                </div>

                {(butPermission?.activeCustomer || butPermission?.allPage) && (
                  <NetFeeBulletin />
                )}
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Customer live bandwidth modal */}
      {/* <BandwidthModal
        setModalShow={setBandWidthModal}
        modalShow={bandWidthModal}
        customer={{ ...bandWidthCustomerData, page: "PPPoE" }}
      /> */}

      {modalStatus === "bandwidth" && (
        <PPPoELiveBandwidth
          show={bandWidthModal}
          setShow={setBandWidthModal}
          customer={bandWidthCustomerData}
        />
      )}

      {/* Customer ONU Information Dialog */}
      {modalStatus === "onuDetails" && (
        <ONUDetails {...{ show, setShow, customer }} />
      )}

      {/* Customer Ping Information Dialog */}
      {modalStatus === "ping" && (
        <PingDetails {...{ show, setShow, customer }} />
      )}

      {/* Customer MAC Vendor Dialog */}
      {modalStatus === "macVendor" && (
        <MacVendor {...{ show, setShow, customer }} />
      )}
    </>
  );
};

export default ResellerActiveCustomer;
